// ** React Imports
import { useEffect, useState } from 'react'

// ** Axios Import
import axios from 'axios'

// ** Type Import
// import { VerticalNavItemsType } from 'src/@core/layouts/types'
import apiUrl from './constant'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { navigation } from './app-navigation';
import { nav } from './app-navigation3';

const ServerSideNavItems = () => {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data.userLoginResponse
    const token = userData.data.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const kolam = JSON.parse(localStorage.getItem('kolam')!)
    const navigate = useNavigate();
    const { logoutUser } = useAuth();
    // ** State
    const [menuItems, setMenuItems] = useState<any>([])

    useEffect(() => {
        let url = ''
        if (cabang == null) {
            const cabangs = {
                "id": 1,
                "nama": "Site 1"
            }
            url = apiUrl.apiUrl + '/api/v1/tambaq/system/menu/list-menu-user/' + cabangs.id
        } else {
            url = apiUrl.apiUrl + '/api/v1/tambaq/system/menu/list-menu-user/' + cabang.id
        }

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                const menu = response.data.data
                setMenuItems(menu)
            })
            .catch(error => {
                if (error.response.status == 401) {
                    logoutUser()
                    navigate("/login");
                }
            })
    }, [])

    return { menuItems }
}

export default ServerSideNavItems
